import api from '@shared/services/api';
import Cookies from 'js-cookie';
export const authService = {
    login: async (formData) => {
        try {
            const response = await api.post('/authenticate', formData, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': 'your-csrf-token-here' // Include CSRF token if needed
                }
            });

            return response.data;
        } catch (error) {
            console.error('Login error:', error);
            throw error;
        }
    },
    logout: async () => {
        try {
            const response = await api.post('/signout', {}, {
                headers: {
                    'Authorization': `Bearer ${Cookies.get('accessToken')}`
                }
            });
            return response.data;
        } catch (error) {
            console.error('Logout error:', error);
            throw error;
        }
    },
    refresh: async (refreshToken) => {
        const response = await api.post('/refresh-token', refreshToken, {
            headers: {
                'Content-Type': 'text/plain' 
            }
        });
        return response;
    },

    specialRights: async () => {
        try {
            const response = await api.get('/user-rights');
            return response.data;
           } catch (error) {
            if (error.response?.status === 404) {
                return [];
            }
            console.error('Roles error:', error);
            throw error;
           }
          
           
    },
    changePassword: async (formData) => {
        try {
            const response = await api.put('/changePassword', formData);
            return response.data;
        } catch (error) {
            console.error('Change password error:', error);
            throw error;
        }
    }
}